import React, { FC } from 'react'
import { brandColors } from 'transfix-ui/theme/colors'

export const Dash: FC = () => <span style={{ color: brandColors.coolGray5 }}>—</span>
